// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9617d46d","455":"50a06fe2","946":"611132a0"}[chunkId] + ".chunk.js";
};